import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-i18next';
import media from 'src/styles/media';

import Page from 'components/Page';
import ScrollAnimation from 'components/ScrollAnimation';
import Hero from './elements/Hero';
import ParallaxCard from './elements/ParallaxCard';
import ParallaxCardFull from './elements/ParallaxCardFull';

import { t, getBaseLocaleURL } from 'src/utils/translate';

class Home extends Component {
  render() {
    const { browser } = this.props;

    return (
      <I18n>
        {(translate, { i18n }) => {
          return (
            <Page
              background={require('src/assets/images/home/bg.jpg')}
              transparent
              banner={<Hero />}
            >
              <Root>
                <Content>
                  <CardsContainer>
                    <ParallaxCard
                      title={t('home.cards.0.title')}
                      subtitle={t('home.cards.0.subtitle')}
                      learnMore={t('home.cards.0.learnMore')}
                      link={`${getBaseLocaleURL(i18n)}/plans`}
                      background={require('src/assets/images/home/floorplans.jpg')}
                      parallax={{
                        offsetYMax: 20,
                        offsetYMin: -20,
                        slowerScrollRate: true,
                        disabled: browser.stageWidth <= 991,
                      }}
                    />
                    <ParallaxCard
                      title={t('home.cards.1.title')}
                      subtitle={t('home.cards.1.subtitle')}
                      learnMore={t('home.cards.1.learnMore')}
                      link={`${getBaseLocaleURL(i18n)}/interiors`}
                      background={require('src/assets/images/home/interiors.jpg')}
                      parallax={{
                        offsetYMax: 40,
                        offsetYMin: -30,
                        slowerScrollRate: true,
                        disabled: browser.stageWidth <= 991,
                      }}
                    />
                  </CardsContainer>

                  <CardContainerFull>
                    <ParallaxCardFull
                      title={t('home.cards.2.title')}
                      subtitle={t('home.cards.2.subtitle')}
                      learnMore={t('home.cards.2.learnMore')}
                      link={`${getBaseLocaleURL(i18n)}/neighbourhood`}
                      background={require('src/assets/images/home/neighbourhood.jpg')}
                      parallax={{
                        offsetYMax: 20,
                        offsetYMin: -20,
                        slowerScrollRate: true,
                        disabled: browser.stageWidth <= 991,
                      }}
                    />
                  </CardContainerFull>

                  <CardsContainer>
                    <ParallaxCard
                      title={t('home.cards.3.title')}
                      subtitle={t('home.cards.3.subtitle')}
                      learnMore={t('home.cards.3.learnMore')}
                      link={`${getBaseLocaleURL(i18n)}/neighbourhood`}
                      background={require('src/assets/images/home/amenities.jpg')}
                      parallax={{
                        offsetYMax: 20,
                        offsetYMin: -20,
                        slowerScrollRate: true,
                        disabled: browser.stageWidth <= 991,
                      }}
                    />
                    <ParallaxCard
                      title={t('home.cards.4.title')}
                      subtitle={t('home.cards.4.subtitle')}
                      learnMore={t('home.cards.4.learnMore')}
                      link={`${getBaseLocaleURL(i18n)}/neighbourhood`}
                      background={require('src/assets/images/home/developer.jpg')}
                      parallax={{
                        offsetYMax: 40,
                        offsetYMin: -30,
                        slowerScrollRate: true,
                        disabled: browser.stageWidth <= 991,
                      }}
                    />
                  </CardsContainer>
                </Content>

                <ScrollAnimation>
                  <Register to={`${getBaseLocaleURL(i18n)}/register`}>{t('home.register')}</Register>
                </ScrollAnimation>
              </Root>
            </Page>
          );
        }}
      </I18n>
    );
  }
}

const Root = styled.div`
  background-size: 100% auto;
  background-position: fixed;
  padding-bottom: 100px;
`;

const Content = styled.div`
  width: 100%;
  max-width: 1245px;
  padding: 0 20px;
  margin: 0 auto;
`;

const cssCardsContainer = css`
  display: flex;
  justify-content: space-between;
  @media (max-width: ${media.md}) {
    display: block;
  }
`;

const CardsContainer = styled.div`
  padding: 100px 0;
  ${cssCardsContainer} & > div {
    width: 49%;
    @media (max-width: ${media.md}) {
      width: 100%;
    }
  }
  @media (max-width: ${media.md}) {
    padding: 0;
  }
`;

const CardContainerFull = styled.div`
  ${cssCardsContainer} & > a {
    width: 100%;
  }
`;

const Register = styled(Link)`
  display: block;
  position: relative;
  padding: 45px 0;
  margin: 0 auto;
  color: #fff;
  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 36px;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 3px;
  &:before,
  &:after {
    content: '';
    width: 55px;
    height: 1px;
    display: inline-block;
    background: #fff;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  &:before {
    top: 0;
  }
  &:after {
    bottom: 0;
  }
`;

const mapStateToProps = state => ({
  browser: state.browser,
});

export default connect(
  mapStateToProps,
  {}
)(Home);



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js